// Design tokens — the single source of truth for color, radius, and elevation.
// Values are the ones already dominant in the codebase, now named.

export const brand = {
  50: "#eeeffa",
  100: "#e0e7ff",
  300: "#818cf8",
  500: "#5664d2",
  600: "#4655c8",
  700: "#4f46e5",
};

// Slate ramp — the neutral scale the UI already uses.
export const slate = {
  50: "#f8fafc",
  100: "#f1f5f9",
  200: "#e2e8f0",
  300: "#cbd5e1",
  400: "#94a3b8",
  500: "#64748b",
  600: "#475569",
  700: "#334155",
  800: "#1e293b",
  900: "#0f172a",
};

export const semantic = {
  // light: icon/badge tint. dark: glyph + text on that tint (5.9:1, AA).
  success: { main: "#10b981", dark: "#15803d", light: "#e8fce8" },
  error: { main: "#ef4444", dark: "#dc2626", light: "#fee2e2" },
  warning: { main: "#f59e0b", dark: "#d97706", light: "#fef3c7" },
  info: { main: "#1976d2", dark: "#1565c0", light: "#e3f2fd" },
};

// Inter for the application, Source Serif 4 for documents a person sits and reads.
// The serif carries lining figures, so the numbers and units in a test table line up.
export const font = {
  sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  serif: '"Source Serif 4", "Iowan Old Style", "Palatino Linotype", Georgia, serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
};

export const radius = { sm: 8, md: 12, lg: 16, pill: 999 };

// Surfaces for clean hierarchy and container boundaries
export const surface = {
  card: "#ffffff",
  subtle: "#f8fafc",
  muted: "#f1f5f9",
  sunken: "#eeeffa",
  border: "#e2e8f0",
  borderHover: "#cbd5e1",
  borderActive: "#818cf8",
  divider: "#e2e8f0",
};

// Offset + soft blur; layered elevation
export const shadow = {
  sm: "0 1px 2px rgba(15,23,42,0.06)",
  md: "0 2px 8px rgba(15,23,42,0.08)",
  lg: "0 4px 20px rgba(15,23,42,0.10)",
  card: "0 1px 3px rgba(15,23,42,0.04), 0 1px 2px rgba(15,23,42,0.02)",
  cardHover: "0 6px 18px rgba(15,23,42,0.08), 0 2px 6px rgba(15,23,42,0.04)",
  modal: "0 12px 36px rgba(15,23,42,0.14), 0 4px 12px rgba(15,23,42,0.06)",
};

// Brand gradients. CSS strings can't resolve theme paths, so they live here
// rather than being retyped per component.
export const gradient = {
  brand: `linear-gradient(135deg, ${brand[500]} 0%, ${brand[600]} 100%)`,
  brandLight: `linear-gradient(135deg, ${brand[500]} 0%, ${brand[300]} 100%)`,
};

export const transition = {
  fast: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
  normal: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  smooth: "all 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
};
